export const GET_ALL_USUARIO = 'GET_ALL_USUARIO'
export const NEW_USUARIO = 'NEW_USUARIO'
export const GET_USUARIO = 'GET_USUARIO'
export const UPD_USUARIO = 'UPD_USUARIO'